import type { RouteMonitoringVisitAddress } from '@/pages/Business/pages/Monitoring/models';
import { asRecord, pickStr } from './object-pickers';

export function normalizeAddress(
  raw: unknown
): RouteMonitoringVisitAddress | null {
  const o = asRecord(raw);
  if (!o) return null;
  return {
    streetName: pickStr(o, 'streetName', 'street_name'),
    doorNumber: pickStr(o, 'doorNumber', 'door_number'),
    apartmentNumber: pickStr(o, 'apartmentNumber', 'apartment_number'),
    lat: pickStr(o, 'lat', 'lat'),
    long: pickStr(o, 'long', 'long'),
  };
}
